export const formatDateByTimezone = (
  dateString,
  timezone,
  fallback = "N/A"
) => {
  if (!dateString || dateString === "Never") {
    return fallback;
  }

  try {
    const date = new Date(dateString);

    const datePart = date.toLocaleDateString("en-IN", {
      timeZone: timezone,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const timePart = date
      .toLocaleTimeString("en-IN", {
        timeZone: timezone,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
      .toLowerCase();

    return `${datePart}, ${timePart}`;
  } catch {
    return fallback;
  }
};